import styled from 'styled-components';
import media from 'utils/mediaStyle';

const Label = styled.div`
  color: rgba(0, 0, 0, 0.54);
  font-size: ${({ fontSize }) => (fontSize ? fontSize : '14px')};
  text-transform: capitalize;
  white-space: nowrap;
  ${media.lg`
    min-width: 112pt;
  `};
  @media (min-width: 1025px) {
    ${({ smallWidth }) =>
      smallWidth &&
      `
      min-width: 70px;
    `}
    ${({ midWidth }) =>
      midWidth &&
      `
      min-width: 120px;
    `}
    ${({ largeWidth }) =>
      largeWidth &&
      `
      min-width: 150pt;
    `}
  }
  ${({textAlign}) => textAlign && `
    text-align: ${textAlign};
  `}
  ${({notMinWidth}) => notMinWidth && `
    min-width: unset !important;
  `}
`;

export default Label;

export const ImageLabel = styled(Label)`
  ${media.lg`
    min-width: auto;
  `};
`;
